import Preact from 'preact';

var FormStructure = {
  fields: {
    headerLabel: {
      validations: []
    },
    WorkingWithPlanner: {
      validations: [] 
    },
    LastName: {
      validations: []
    },
    FirstName: {
      validations: []
    },
    Email: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' },
        { type: 'regex', pattern: '[a-z0-9!#$%&\'*+/=?^_`{|}~-]+(?:\\.[a-z0-9!#$%&\'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?', message: 'Please provide a valid email.' },
      ]
    },
    TelNumber: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' },
        { type: 'regex', pattern: '[(]{0,1}[0-9]{3}[) ]{0,2}[-\\s\\.]{0,1}[0-9]{3}[-\\s\\.]{0,1}[0-9]{4}', message: 'Please provide a valid phone number.' },
      ]
    },
    clientname: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' },
      ]
    },
    AddressLine1: {
      validations: []
    },
    City: {
      validations: []
    },
    State: {
      validations: []
    },
    Postal: {
      validations: []
    },
    EventDate: {
      validations: [
        { type: 'dateinfuture', message: 'Event date must be in the future.' },
        { type: 'required', message: 'Please fill in required field.' },
      ]
    },
    StartTime: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' },
      ]
    },
    EndTime: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' },
      ]
    }, 
    Operation: {
      validations: [
      { type: 'required', message: 'Please provide a selection' },
      ]
    },
    SiteName: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' },
      ]
    },
    Category: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' },
      ]
    },
    PlannedGuestCount: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' },
      ]
    },
    // FIXED: Added type and options here for logic synchronization
    Reference: {
      type: 'select',
      options: [
        { label: 'Social Media', value: 'Social Media' },
        { label: 'Google', value: 'Google' },
        { label: 'Family/Friend', value: 'Family/Friend' },
        { label: 'Business referral', value: 'Business referral' },
        { label: 'Venue referral', value: 'Venue referral' },
        { label: 'I saw Sole Power at an event', value: 'I saw Sole Power at an event' },
      ],
      validations: [
        { type: 'required', message: 'Please let us know how you heard about us.' },
      ]
    },
    EventExtra2: {
      validations: []
    },    
    Notes: {
      validations: []
    }
  },
  layout: {
    rows: [
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Contact Last Name (If different from the billing name Example: Event Planner):',
            mapping: 'LastName'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Contact First Name (If different from the billing name Example: Event Planner):',
            mapping: 'FirstName'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Email:*',
            mapping: 'Email'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Phone:*',
            mapping: 'TelNumber'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Billing Name (Last Name & First Name or Company Name):*',
            mapping: 'clientname'
          },
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Billing Address:',
            mapping: 'AddressLine1'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'City:',
            mapping: 'City'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Province/State:',
            mapping: 'State'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Postal/Zip Code:',
            mapping: 'Postal'
          }
        ]
      },
      {
        fields: [
          {
            type: 'date-picker',
            size: 'Medium',
            label: 'Event Date',
            mapping: 'EventDate'
          }
        ]
      },
       {
        fields: [
          {
            type: 'checkbox-list',
            size: 'Medium',
            label: 'Which services are you interested in? (Check at least one option)*',
            options: [
              { label: 'DJ'  , value: 'DJ'},
              { label: 'Band'  , value: 'Band'},
              { label: 'Live Music'  , value: 'Live Music'},
              { label: 'Photo Booth'  , value: 'Photo Booth'},
              { label: 'Specialty Acts'  , value: 'Specialty Acts'},
              { label: 'Audio Visual'  , value: 'Audio Visual'},
              { label: 'Talent Buying'  , value: 'Talent Buying'},
            ],
            mapping: 'Operation'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Venue',
            mapping: 'SiteName'
          }
        ]
      },
      {
        fields: [
          {
            type: 'multiple-choice',
            size: 'Medium',
            label: 'Type of Event',
            options: [
                { label: 'Corporate Conference'  , value: 'Corporate Conference'},
                { label: 'Corporate Event'  , value: 'Corporate Event'},
                { label: 'Corporate Gala'  , value: 'Corporate Gala'},
                { label: 'Corporate Holiday Party'  , value: 'Corporate Holiday Party'},
                { label: 'Wedding'  , value: 'Wedding'},
                { label: 'Mitzvah'  , value: 'Mitzvah'},
                { label: 'Birthday'  , value: 'Birthday'},
                { label: 'Sporting Event'  , value: 'Sporting Event'},
                { label: 'Other'  , value: 'Other'},
            ],
            mapping: 'Category'
          }
        ]
      },
      {
        fields: [
          {
            type: 'multiple-choice',
            size: 'Medium',
            label: 'How many guests are you expecting?',
            options: [
            { label: '0-100'  , value: '0-100'},
            { label: '101-200'  , value: '101-200'},
            { label: '201-300'  , value: '201-300'},
            { label: '301-400'  , value: '301-400'},
            { label: '401-500'  , value: '401-500'},
            { label: '501 +'  , value: '501 +'},
            ],
            mapping: 'PlannedGuestCount'
          }
        ]
      },
      {
        fields: [
          {
            // FIXED: Set to 'select' and ensured options match top-level fields
            type: 'select', 
            size: 'Medium',
            label: 'How Did You Hear About Us?*',
            options: [
              { label: 'Social Media', value: 'Social Media' },
              { label: 'Google', value: 'Google' },
              { label: 'Family/Friend', value: 'Family/Friend' },
              { label: 'Business referral', value: 'Business referral' },
              { label: 'Venue referral', value: 'Venue referral' },
              { label: 'I saw Sole Power at an event', value: 'I saw Sole Power at an event' },
            ],
            mapping: 'Reference'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text-area',
            size: 'Medium',
            label: 'Is there anything more you would like us to know about your event? Don\'t be shy!',
            mapping: 'Notes'
          }
        ]
      },
      {
        fields: [
          {
            type: 'submit',
            size: 'XLarge',
            label: ''
          }
        ]
      }
    ]
  },
  info: {
    title: 'Sole Power Productions Contact Form',
    formId: '2266',
    clientKey: 'D0FC2C05-0BD0-409F-B350-6AF719A33F88',
    appKey: '23697F14-AA8C-4622-9F64-FC1A9FF20D0D',
    redirectUrl: '',
    submissionText: 'We can\'t wait to chat further about your event!',
    apiEndpoint: 'https://api-cec.catereasewebtools.com/inbound-inquiries'

  }
};

export default FormStructure;